import {
  PMultiSelect,
  PMultiSelectOption,
  PMultiSelectProps,
  PSelect,
  PSelectOption,
  PSelectProps,
} from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';

import { App } from '@/config/app';
import { NAMESPACES } from '@/config/i18n';

export const ApplicationSelect = ({
  includeDashboardOption = false,
  ...props
}: PSelectProps & {
  includeDashboardOption?: boolean;
}) => {
  const options = useTranslatedOptions({ includeDashboardOption });

  return (
    <PSelect {...props}>
      {options.map(({ value, label }) => (
        <PSelectOption key={value} value={value}>
          {label}
        </PSelectOption>
      ))}
    </PSelect>
  );
};

export const MultiApplicationSelect = ({
  includeDashboardOption = false,
  ...props
}: PMultiSelectProps & {
  includeDashboardOption?: boolean;
}) => {
  const options = useTranslatedOptions({ includeDashboardOption });

  return (
    <PMultiSelect {...props}>
      {options.map(({ value, label }) => (
        <PMultiSelectOption key={value} value={value}>
          {label}
        </PMultiSelectOption>
      ))}
    </PMultiSelect>
  );
};

const useTranslatedOptions = ({
  includeDashboardOption,
}: {
  includeDashboardOption?: boolean;
}) => {
  const { t } = useTranslation(NAMESPACES);

  const application = {
    [App.FieldForceManagement]: t('common:app.ffm'),
    [App.Greenland]: t('common:app.greenland'),
    [App.PorscheImportAgreements]: t('common:app.porscheImportAgreements'),
    [App.PorscheStrategy2030]: t('common:app.porscheStrategy2030'),
    [App.NetworkPlanning]: t('common:app.networkPlanning'),
    [App.RetailDesign]: t('common:app.retailDesign'),
    [App.Survey]: t('common:app.survey'),
    [App.MultisensoryExperience]: t('common:app.multisensoryExperience'),
    [App.PcRoadmap]: t('common:app.pcRoadmap'),
    [App.Apex]: t('common:app.apex'),
    [App.RealEstate]: t('common:app.realEstate'),
  };

  const options = [
    ...(includeDashboardOption
      ? [{ value: 'DASHBOARD', label: t('common:app.dashboard') }]
      : []),
    ...Object.entries(application).map(([value, label]) => ({
      value,
      label,
    })),
  ].toSorted((a, b) => a.label.localeCompare(b.label));

  return options;
};
